import { Box } from '@chakra-ui/react'

import { Dropzone } from 'components'
import { UploadFile } from 'types'

type QuestionProps = {
  type?: string
}

export default function MultipleUploadDropzoneOnCustomForm({}: QuestionProps) {
  async function onUpload(file: UploadFile) {
    console.log('file', file)
  }

  return (
    <Box>
      <Dropzone isDisabled onUpload={onUpload} validation={{ maxSize: 500000000 }} />
    </Box>
  )
}
